import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

const EditModal = ({ isOpen, onClose, onSave, title, children, isSaving, hasChanges, isReview=false }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen]);
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-gray-600 bg-opacity-50 p-3">
      <div className="relative bg-white transform scale-[0.8] 2xl:scale-100 xl:scale-100 md:scale-100 sm:scale-[0.9]  rounded-lg shadow-xl w-full max-w-2xl mx-auto my-8" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            aria-label="Close modal"
            disabled={isSaving}
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-4 pb-1">
          {children}
        </div>

        {/* Modal Footer */}
        {
          !isReview && (
   <div className="flex justify-end gap-3 p-2">
          {/* <button
            className="px-4 py-1 rounded rounded-2xl bg-gray-200 text-gray-333 text-xs"
            onClick={onClose}
            disabled={isSaving} 
          >
            Cancel
          </button> */}
          <button
            onClick={onSave}
            disabled={isSaving || !hasChanges} // Disable if no changes or saving
            className={`px-4 py-2 rounded-full bg-gradient text-white text-xs font-semibold hover:shadow-lg ${isSaving || !hasChanges
                ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                : 'profiler-bg text-white hover:opacity-90'
              }`}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </div>
          )
        }
     
          {
          isReview && (
   <div className="flex justify-end gap-3 p-2">
          {/* <button
            className="px-4 py-1 rounded rounded-2xl bg-gray-200 text-gray-333 text-xs"
            onClick={onClose}
            disabled={isSaving} 
          >
            Cancel
          </button> */}
          <button
            onClick={onSave}
            disabled={isSaving } // Disable if no changes or saving
            className={`px-4 py-2 rounded-full bg-gradient text-white text-xs font-semibold hover:shadow-lg ${isSaving 
                ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                : 'profiler-bg text-white hover:opacity-90'
              }`}
          >
            {isSaving ? 'Loading..' : 'Ok'}
          </button>
        </div>
          )
        }
      </div>
    </div>
  );
};

export default EditModal;